import _axios, {AxiosError} from "axios";
import firebase from "config/firebase";
import {signOut} from "firebase/auth";
import {handleError} from "helpers/errors";

export const CAS_FRONTEND_URL =
  window.location.hostname === "app.booksmatch.us"
    ? "https://akadian.booksmatch.us"
    : window.location.hostname === "fastandeasyqbo.booksmatch.us"
      ? "https://akadian.booksmatch.us"
      : window.location.hostname === "dev.booksmatch.us"
        ? "https://akadian-dev.booksmatch.us"
        : (process.env.REACT_APP_CAS_FRONTEND_URL ?? "https://akadian.booksmatch.us");

export const FASTANDEASY_FRONTEND_URL =
  process.env.REACT_APP_FASTANDEASY_FRONTEND_URL ?? "https://fastandeasyqbo.booksmatch.us";

// ─── Dashboard target toggle ──────────────────────────────────────────────────
// Switch between "cas" (xperiencify) and "fastandeasy" (booksmatch-hosted LMS)
export const DASHBOARD_TARGET: "cas" | "fastandeasy" = "cas" as "cas" | "fastandeasy";
// ─────────────────────────────────────────────────────────────────────────────

export const DASHBOARD_URL = DASHBOARD_TARGET === "fastandeasy" ? FASTANDEASY_FRONTEND_URL : CAS_FRONTEND_URL;

export const PREVIEW_URL =
  window.location.hostname === "localhost" ? "https://dev.booksmatch.us/preview" : `${window.location.origin}/preview`;

export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5001/booksmatch-f6ac0/us-central1/api"
    : "https://app.booksmatch.us/api";

export const noAuthAxios = _axios.create({
  baseURL: API_URL,
});

const axios = _axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use(async (config) => {
  const bearer = await firebase.auth.currentUser?.getIdToken();

  config.headers.setAuthorization(`Bearer ${bearer}`);

  return config;
});

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err: AxiosError<({type?: string} & Record<string, unknown>) | string>) => {
    if (err.status === 401) {
      await signOut(firebase.auth);

      return;
    } else if (err.status === 503) {
      throw err; // custom error handling
    } else if (err.response?.data && typeof err.response?.data !== "string" && err.response.data.type) {
      throw err.response.data;
    } else {
      handleError((err.response?.data as string) || "An unknown error occurred");
      throw err;
    }
  },
);

export default axios;
